import { FILTER_DISPLAY } from "@/modules/Dashboards/AdminDashboard/constants/AdminDashboardConstants";
import { Filter } from "@/modules/Dashboards/AdminDashboard/models/Filter";
import { SecondaryFilter } from "@/modules/Dashboards/AdminDashboard/models/SecondaryFilter";
import { OPERATORS_FILTERS } from "@/shared/constants/GeneralConstants";

export const ACTION_PLAN_CONSTANTS = {
  PAGE_TITLE: "Plan de acción",
  ADD_PAGE_TITLE: "Agregar plan de acción",
  EDIT_PAGE_TITLE: "Editar plan de acción",
  PAGE_TITLE_SEARCH: "Consulta de planes de acción",
  BUTTON: {
    ADD: "Crear plan de acción",
    CLOSE: "Cancelar"
  },
  MESSAGES: {
    CREATED: "Plan de acción creado correctamente",
    ALREADY_EXIST: "El nombre de plan de acción ya existe",
    UPDATED: "Plan de acción actualizado correctamente",
    DELETED: "Plan de acción eliminado correctamente",
    USED: "El plan de acción está en uso, no se puede eliminar",
    CLOSE_VIEW: "se debe guardar o cancelar la vista",
    SAME_NAME: "no se permiten variables con le mismo nombre"
  },
  ID_REF_GO_TO: "headerPanelForm",
  TITLES: {
    NAME: "Nombre Plan de acción*",
    CATEGORY: "Categoria del Plan de acción*",
    ACTION_PLAN_CONFIG: "Configuración del plan de acción",
    SOURCE_DATA: "Creación fuente de información",
    FILTER_CATEGORY_FORM: "Filtrar formulario por categoria",
    SELECT_SERVICE: "Seleccione el servicio*",
    SELECT_INFO_GROUP: "Seleccione los grupos de información",
    SELECT_FORM: "Seleccione los formularios",
    OUT_DATA: "Destino de información",
    TEMPLATE_PDF: "Seleccione la plantilla PDF*",
    CREATE_DATA: "Creación del Plan de acción",
    INFO_CREATE:
      "Busque y seleccion la fuente de informacion que requiere, luego el campo de información",
    CONFIG_HEADER: "Información del encabezado",
    SECCION_SERVICE: "Seccion del servicio",
    SELECT_FORM_INPUT: "Seleccione el formulario",
    TITLE_VARIABLE: "Variables",
    INFO_VARIABLE:
      "Cree la variable seleccionando el formulario,luego formule la operacion",
    NAME_VARIABLE: "Nombre de la variable",
    FORMULA_VARIABLE: "Creacion de la variable",
    ADD_VARIABLE: "Agregar variable"
  },
  TAB: {
    CREATE_DATA: "CREACIÓN DEL PLAN DE ACCIÓN",
    PREVIEW: "VISTA PREVIA"
  },
  GRAPH: {
    TITLE: "Plan de acción",
    NAME_KEY_DATA: "actionPlanChart"
  },
  CATEGORY_ID: "Cz1jDBxNAFdHBdMjRqvx",
  QUERY_SEARCH: {
    SECTIONS: "sections",
    ACTION_PLAN: "ActionPlan",
    INFO_GROUP: "infoGroup"
  },
  EMITTERS: {
    FETCH_PDF_LIST: "fetchPdfList",
    UPDATE_PDF_LIST: "update:pdfArraySelect",
    TEMPLATE_SELECTED: "templateSelected"
  }
};

export const ACTION_PLAN_SECONDARY_FILTERS: SecondaryFilter[] = [
  {
    name: "Nombre",
    placeholder: "Nombre de Plan de accion",
    key: "name",
    avatar: "mdi-form-textbox",
    type: "secondaryFilter",
    disabled: true,
    operators: OPERATORS_FILTERS,
    display: FILTER_DISPLAY.UNIQUE,
    default: true
  },
  {
    name: "Estado",
    placeholder: "Estado de Plan de accion",
    key: "state",
    avatar: "mdi-list-status",
    type: "secondaryFilter",
    disabled: true,
    operators: OPERATORS_FILTERS,
    display: FILTER_DISPLAY.LIST,
    options: [
      { name: "Activo", key: "Activo" },
      { name: "Inactivo", key: "Inactivo" }
    ]
  }
];

export const FORM_FILTERS_ACTION_PLAN: Filter[] = [
  {
    mainFilterKey: "forms",
    mainFilterName: "Todos",
    avatar: "mdi-animation",
    initial: true,
    secondaryFilters: ACTION_PLAN_SECONDARY_FILTERS
  }
];

export const SEARCH_CONTEXT_DESCRIPTIONS = ["state"];

export const ACTION_PLAN_ACCESS = {
  GET: "consultar plan de acción",
  POST: "crear plan de acción",
  PUT: "modificar plan de acción",
  DELETE: "eliminar plan de acción"
};

export const EVENT_VALID_NAME_FIELD = "nameIsValid";
